export const SHOW_MODAL = 'SHOW_MODAL';
export const HIDE_MODAL = 'HIDE_MODAL';

export const FETCH_PROFILE_REQUEST = 'FETCH_PROFILE_REQUEST';
export const FETCH_PROFILE_SUCCESS = 'FETCH_PROFILE_SUCCESS';
export const FETCH_PROFILE_ERROR =   'FETCH_PROFILE_ERROR';

export const FETCH_POST_REQUEST = 'FETCH_POST_REQUEST';
export const FETCH_POST_SUCCESS = 'FETCH_POST_SUCCESS';
export const FETCH_POST_ERROR =   'FETCH_POST_ERROR';

export const FETCH_POSTS_REQUEST = 'FETCH_POSTS_REQUEST';
export const FETCH_POSTS_SUCCESS = 'FETCH_POSTS_SUCCESS';
export const FETCH_POSTS_ERROR =   'FETCH_POSTS_ERROR';

export const FETCH_COMMENTS_REQUEST = 'FETCH_COMMENTS_REQUEST';
export const FETCH_COMMENTS_SUCCESS = 'FETCH_COMMENTS_SUCCESS';
export const FETCH_COMMENTS_ERROR =   'FETCH_COMMENTS_ERROR';

export const TOGGLE_DIRECTION_AND_EMPTY_ITEMS = 'TOGGLE_DIRECTION_AND_EMPTY_ITEMS';
export const UPDATE_WHEEL = 'UPDATE_WHEEL';

export const REQUEST_CHAT_REQUEST = 'REQUEST_CHAT_REQUEST';
export const REQUEST_CHAT_SUCCESS = 'REQUEST_CHAT_SUCCESS';
export const REQUEST_CHAT_ERROR = 'REQUEST_CHAT_ERROR';

export const PORTAL_FETCH_CATEGORIES_REQUEST = 'PORTAL_FETCH_CATEGORIES_REQUEST';
export const PORTAL_FETCH_CATEGORIES_SUCCESS = 'PORTAL_FETCH_CATEGORIES_SUCCESS';
export const PORTAL_FETCH_CATEGORIES_ERROR   = 'PORTAL_FETCH_CATEGORIES_ERROR';

export const PORTAL_FETCH_EVENTS_REQUEST = 'PORTAL_FETCH_EVENTS_REQUEST';
export const PORTAL_FETCH_EVENTS_SUCCESS = 'PORTAL_FETCH_EVENTS_SUCCESS';
export const PORTAL_FETCH_EVENTS_ERROR   = 'PORTAL_FETCH_EVENTS_ERROR';

export const PORTAL_FETCH_PROFILES_RECOMMEND_RANDOM_REQUEST = 'PORTAL_FETCH_PROFILES_RECOMMEND_RANDOM_REQUEST';
export const PORTAL_FETCH_PROFILES_RECOMMEND_RANDOM_SUCCESS = 'PORTAL_FETCH_PROFILES_RECOMMEND_RANDOM_SUCCESS';
export const PORTAL_FETCH_PROFILES_RECOMMEND_RANDOM_ERROR   = 'PORTAL_FETCH_PROFILES_RECOMMEND_RANDOM_ERROR';

export const PORTAL_FETCH_PROFILES_RISE_REQUEST = 'PORTAL_FETCH_PROFILES_RISE_REQUEST';
export const PORTAL_FETCH_PROFILES_RISE_SUCCESS = 'PORTAL_FETCH_PROFILES_RISE_SUCCESS';
export const PORTAL_FETCH_PROFILES_RISE_ERROR   = 'PORTAL_FETCH_PROFILES_RISE_ERROR';

export const PORTAL_SCROLL_PROFILES_RISE_REQUEST = 'PORTAL_SCROLL_PROFILES_RISE_REQUEST';
export const PORTAL_SCROLL_PROFILES_RISE_SUCCESS = 'PORTAL_SCROLL_PROFILES_RISE_SUCCESS';

export const PORTAL_FETCH_COUPON_RECEIVED_REQUEST = 'PORTAL_FETCH_COUPON_RECEIVED_REQUEST';
export const PORTAL_FETCH_COUPON_RECEIVED_SUCCESS = 'PORTAL_FETCH_COUPON_RECEIVED_SUCCESS';
export const PORTAL_FETCH_COUPON_RECEIVED_ERROR   = 'PORTAL_FETCH_COUPON_RECEIVED_ERROR';

export const PORTAL_FETCH_COUPON_RECOMMEND_REQUEST = 'PORTAL_FETCH_COUPON_RECOMMEND_REQUEST';
export const PORTAL_FETCH_COUPON_RECOMMEND_SUCCESS = 'PORTAL_FETCH_COUPON_RECOMMEND_SUCCESS';
export const PORTAL_FETCH_COUPON_RECOMMEND_ERROR   = 'PORTAL_FETCH_COUPON_RECOMMEND_ERROR';

export const PORTAL_RECEIVE_COUPON = 'PORTAL_RECEIVE_COUPON';
export const PORTAL_ADD_FRIEND = 'PORTAL_ADD_FRIEND';
export const PORTAL_BLOCK_FRIEND = 'PORTAL_BLOCK_FRIEND';

export const PORTAL_UPDATE_CATEGORY_MORE = 'PORTAL_UPDATE_CATEGORY_MORE';
export const PORTAL_UPDATE_COUPON_MORE = 'PORTAL_UPDATE_COUPON_MORE';

export const FETCH_MEMBERSHIP_REQUEST = 'FETCH_MEMBERSHIP_REQUEST';
export const FETCH_MEMBERSHIP_SUCCESS = 'FETCH_MEMBERSHIP_SUCCESS';
export const FETCH_MEMBERSHIP_ERROR   = 'FETCH_MEMBERSHIP_ERROR';


// WEBPACK FOOTER //
// ./src/constants/ActionTypes.js